<ng-container *ngIf="{ isMobileWebView: isMobileWebView$ | async } as vm">
  <page-title text="Escalate Ticket | BitOasis" i18n-text="@@pageTitle.escalationPage.title"></page-title>
  <site-layout class="push narrow" [hideHeader]="vm.isMobileWebView">

    <h2 class="text-header text-bold text-center mb-2" i18n="@@front.escalationPage.title">
      Ticket Escalation </h2>
    <p class="text-lg text-center" i18n="@@front.escalationPage.subtitle">
      To escalate your ticket, please leave your email and ticket ID below </p>
    <div class="p-3"></div>
    <escalation-ticket></escalation-ticket>
    <p *ngIf="!vm.isMobileWebView" class="m-3 text-center" i18n="@@front.support.knowledgeCenter">
      Do you have questions? Check our
      <a [href]="isAr ? links.support.ar : links.support.en" target="_blank" rel="noopener">
        Support
      </a>
    </p>
  </site-layout>
  <site-footer *ngIf="!vm.isMobileWebView"></site-footer>
</ng-container>